import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  width: "19",
  height: "19",
  viewBox: "0 0 19 19",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M3.5 11.5029C3.91421 11.5029 4.25 11.8387 4.25 12.2529V13.0029C4.25 13.4008 4.40804 13.7823 4.68934 14.0636C4.97064 14.3449 5.35217 14.5029 5.75 14.5029L13.25 14.5029C13.6478 14.5029 14.0294 14.3449 14.3107 14.0636C14.592 13.7823 14.75 13.4008 14.75 13.0029V12.2529C14.75 11.8387 15.0858 11.5029 15.5 11.5029C15.9142 11.5029 16.25 11.8387 16.25 12.2529V13.0029C16.25 13.7986 15.9339 14.5616 15.3713 15.1243C14.8087 15.6869 14.0456 16.0029 13.25 16.0029L5.75 16.0029C4.95435 16.0029 4.19129 15.6869 3.62868 15.1242C3.06607 14.5616 2.75 13.7986 2.75 13.0029L2.75 12.2529C2.75 11.8387 3.08579 11.5029 3.5 11.5029Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("path", {
  d: "M10.0303 12.7833C9.73744 13.0762 9.26256 13.0762 8.96967 12.7833L5.96967 9.78326C5.67678 9.49037 5.67678 9.01549 5.96967 8.7226C6.26256 8.42971 6.73744 8.42971 7.03033 8.7226L8.75 10.4423L8.75 3.25293C8.75 2.83872 9.08579 2.50293 9.5 2.50293C9.91421 2.50293 10.25 2.83872 10.25 3.25293L10.25 10.4423L11.9697 8.7226C12.2626 8.42971 12.7374 8.42971 13.0303 8.7226C13.3232 9.01549 13.3232 9.49037 13.0303 9.78326L10.0303 12.7833Z",
  fill: "currentColor"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("svg", _hoisted_1, [
    _hoisted_2,
    _hoisted_3
  ]))
}